const locale = 'en-US';

export function Currency({ value, maximumFractionDigits }) {
  if (isNaN(value) || value === null) {
    return null;
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: maximumFractionDigits || 0,
    minimumFractionDigits: 0,
  }).format(value);
}

export function Percentage({ value, maximumFractionDigits }) {
  if (isNaN(value) || value === null) {
    return null;
  }

  return new Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits: isNaN(maximumFractionDigits) ? 3 : maximumFractionDigits,
  }).format(value);
}

export function Number({ value, maximumFractionDigits, isAccountingFormat, isCompact }) {
  if (isNaN(value) || value === null) {
    return null;
  }

  maximumFractionDigits =
    maximumFractionDigits === undefined ? 2 : maximumFractionDigits;

  const output = new Intl.NumberFormat(locale, {
    maximumFractionDigits: maximumFractionDigits,
    notation: isCompact ? 'compact' : 'standard',
  }).format(value);

  if (isAccountingFormat && value < 0) {
    return `(${output.replace('-', '')})`;
  }

  return output;
}

export function numberFormat(value, { maximumFractionDigits, isAccountingFormat, isCompact } = {}) {
  if (isNaN(value) || value === null) {
    return null;
  }

  maximumFractionDigits =
    maximumFractionDigits === undefined ? 0 : maximumFractionDigits;
  const output = new Intl.NumberFormat(locale, {
    maximumFractionDigits: maximumFractionDigits,
    notation: isCompact ? 'compact' : 'standard',
  }).format(value);

  if (isAccountingFormat && value < 0) {
    return `(${output.replace('-', '')})`;
  }

  return output;
}

export function currencyFormat(
  value,
  { maximumFractionDigits, isCompact } = {}
) {
  if (isNaN(value) || value === null) {
    return null;
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: maximumFractionDigits || 0,
    minimumFractionDigits: 0,
    notation: isCompact ? 'compact' : 'standard',
  }).format(value);
}

export function getCurrencyFormat(overrideMaximumFractionDigits) {
  return function(value, { maximumFractionDigits, isCompact } = {})
  {
    if (isNaN(value) || value === null) {
      return null;
    }

    const mfd = isNaN(overrideMaximumFractionDigits) ? (isNaN(maximumFractionDigits)? 1 : maximumFractionDigits) : overrideMaximumFractionDigits

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: mfd || 0,
      minimumFractionDigits: 0,
      notation: isCompact ? 'compact' : 'standard',
    }).format(value);
  }
}
export function percentageFormat(value, { maximumFractionDigits } = {}) {
  if (isNaN(value) || value === null) {
    return null;
  }

  return new Intl.NumberFormat(locale, {
    style: 'percent',
    maximumFractionDigits: isNaN(maximumFractionDigits) ? 3 : maximumFractionDigits,
  }).format(value);
}

export function getPercentageFormat(overrideMaximumFractionDigits = 3) {
  return function(value, { maximumFractionDigits } = {})
  {
    if (isNaN(value) || value === null) {
      return null;
    }

    const mfd = isNaN(overrideMaximumFractionDigits) ? (isNaN(maximumFractionDigits)? 3 : maximumFractionDigits) : overrideMaximumFractionDigits

    return new Intl.NumberFormat(locale, {
      style: 'percent',
      maximumFractionDigits: mfd || 0,
    }).format(value);
  }
}
